/**
 * Take-off point marker — a map pin with a quadcopter pictogram. Own inline SVG (no external image
 * asset, nothing to attribute). The icon anchor is exactly the pin's tip, marked by a small dot, so the
 * marked point is visible precisely at any zoom; a white outline and drop shadow keep it readable over
 * every base map and over the flight area / corridor fill.
 */
import L from 'leaflet';

const WIDTH = 40;
const HEIGHT = 52;
// Tip of the pin = the take-off coordinate.
const TIP_X = 20;
const TIP_Y = 48;

const buildSvg = (fill) => `
<svg xmlns="http://www.w3.org/2000/svg" width="${WIDTH}" height="${HEIGHT}" viewBox="0 0 ${WIDTH} ${HEIGHT}" aria-hidden="true">
  <path d="M${TIP_X} ${TIP_Y} C${TIP_X} ${TIP_Y} 5 31 5 19 A15 15 0 1 1 35 19 C35 31 ${TIP_X} ${TIP_Y} ${TIP_X} ${TIP_Y} Z"
        fill="${fill}" stroke="#ffffff" stroke-width="2.5" stroke-linejoin="round"/>
  <g stroke="#ffffff" stroke-width="1.6" fill="none" stroke-linecap="round">
    <line x1="14.5" y1="13.5" x2="25.5" y2="24.5"/>
    <line x1="25.5" y1="13.5" x2="14.5" y2="24.5"/>
    <circle cx="13" cy="12" r="3.6"/>
    <circle cx="27" cy="12" r="3.6"/>
    <circle cx="13" cy="26" r="3.6"/>
    <circle cx="27" cy="26" r="3.6"/>
  </g>
  <rect x="17" y="16" width="6" height="6" rx="1.5" fill="#ffffff"/>
  <circle cx="${TIP_X}" cy="${TIP_Y}" r="3.2" fill="#ef4444" stroke="#ffffff" stroke-width="1.5"/>
</svg>`;

const createIcon = (fill, draggable) => L.divIcon({
  // Own class instead of Leaflet's default `leaflet-div-icon` (white box with a border).
  className: 'fleetora-takeoff-marker',
  html: `<div style="filter: drop-shadow(0 2px 3px rgba(0,0,0,0.45)); cursor: ${draggable ? 'grab' : 'pointer'}; line-height: 0;">${buildSvg(fill)}</div>`,
  iconSize: [WIDTH, HEIGHT],
  iconAnchor: [TIP_X, TIP_Y],
  popupAnchor: [0, -HEIGHT + 6],
  tooltipAnchor: [0, -HEIGHT + 10],
});

// Created once — Leaflet re-creates the DOM node whenever a Marker gets a new icon instance.
export const takeoffIconEditable = createIcon('#1E3A5F', true);
export const takeoffIconReadonly = createIcon('#1E3A5F', false);
